export default "__VITE_ASSET__9dca2784__"